var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#F0F0F0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2400 5114 c-393 -33 -695 -110 -1015 -259 -160 -74 -375 -207 -509 -314 -21 -17 -42 -31 -47 -31 -4 0 -59 93 -121 206 -62 113 -121 214 -131 225 -26 28 -84 22 -108 -11 -9 -14 -111 -344 -225 -734 -223 -762 -219 -743 -162 -775 25 -14 63 -4 750 197 763 224 758 222 758 281 0 40 -26 60 -209 160 l-163 89 64 45 c308 220 682 358 1077 397 510 50 1059 -97 1479 -397 l63 -45 -172 -95 c-95 -52 -179 -102 -186 -111 -18 -24 -16 -66 5 -91 13 -15 189 -71 740 -233 687 -201 725 -211 750 -197 57 32 61 13 -162 775 -114 390 -216 720 -225 734 -24 33 -82 39 -108 11 -10 -11 -69 -113 -132 -226 -65 -119 -118 -204 -125 -202 -6 3 -51 35 -101 72 -364 271 -805 448 -1270 509 -117 16 -426 28 -515 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2521 3320 c-39 -9 -76 -35 -105 -74 -21 -27 -21 -31 -24 -1453 l-2 -1426 25 -42 c28 -49 90 -85 145 -85 54 0 117 36 145 84 l25 43 0 1411 c0 975 -3 1419 -11 1439 -28 76 -116 121 -198 103z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 2696 l-34 -34 0 -1287 c0 -1435 -5 -1326 68 -1361 45 -21 93 -13 140 23 119 90 1494 1212 1525 1244 31 32 37 45 37 82 0 30 -7 54 -22 75 -18 25 -1343 1111 -1536 1259 -36 27 -52 33 -94 33 -44 0 -54 -4 -84 -34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4778 2697 c-193 -148 -1518 -1234 -1535 -1259 -27 -37 -31 -103 -7 -136 22 -31 1558 -1280 1589 -1292 55 -21 119 0 148 49 16 27 17 121 17 1316 l0 1287 -34 34 c-30 30 -40 34 -84 34 -42 0 -58 -6 -94 -33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipUp);
export default __webpack_public_path__ + "static/media/flip-up.22d70b2e1342bc9e2b658b18c6b219ee.svg";
export { ForwardRef as ReactComponent };